import React from "react";
import s from "./current-package-card.module.scss";
import classNames from "classnames";
import { useActivePacks } from "@shared/api/useActivePacks";
import { IconBooks, IconMusic, IconSchool, IconChevronRight } from "@tabler/icons-react";
import { NavLink, useNavigate } from "react-router-dom";
import { getNoun } from "@utils/lib/getNoun";
import { Button } from "@shared/ui/button/button";

export const CurrentPackageCard = ({ className }) => {
	const { data: activePacks, isFetched } = useActivePacks()
	const navigate = useNavigate()

	const pack = activePacks?.data?.[0]

	if (!isFetched || !pack) {
	// if (!isFetched || false) {
		return null
	}

	const total = pack?.lessons_count ?? 0
	const used = pack?.lessons_used ?? 0
	// const total = 5
	// const used = 5
	const hasRemainingLessons = used < total
	const teacherSlug = pack?.teacher?.teacher_slug
	const instrumentId = pack?.instrument?.id
	// const teacherSlug = 'erik-kartman-9tlvv'
	// const instrumentId = 2
	const bookingPath = teacherSlug
		? `/teacher/booking/${teacherSlug}${instrumentId ? `?instrument=${instrumentId}` : ''}`
		: '/teachers'
	const buyPackPath = teacherSlug
		? `/teacher/packs/${teacherSlug}${instrumentId ? `?instrument=${instrumentId}` : ''}`
		: '/teachers'

	const handleBook = (e) => {
		e.preventDefault()
		e.stopPropagation()
		navigate(hasRemainingLessons ? bookingPath : buyPackPath)
	}

	return (
		<NavLink className={classNames(className, s.currentPackageCard)} to="/history">
			<div className={s.header}>
				<div className={s.iconWrapper}>
					<IconBooks size={24} />
				</div>
				<div className={s.headerText}>
					<div className={s.title}>Текущий пакет</div>
					<div className={s.subtitle}>
						Использовано {used} из {total} {getNoun(total, "занятия", "занятий", "занятий")}
					</div>
				</div>
				<NavLink to="/history" className={s.arrow}>
					<IconChevronRight size={24} />
				</NavLink>
			</div>

			<div className={s.progress}>
				{Array.from({ length: total }).map((_, index) => (
					<div
						key={index}
						className={classNames(s.progressSegment, index < used && s.active)}
					/>
				))}
			</div>

			<div className={s.tags}>
				<div className={s.tag}>
					<IconMusic size={14} />
					<span>{pack?.instrument?.name}</span>
				</div>
				<div className={s.tag}>
					<IconSchool size={14} />
					<span>{pack?.teacher?.name}</span>
				</div>
			</div>
			<Button label={hasRemainingLessons ? 'Записаться по пакету' : 'Купить новый пакет'} className={s.bookButton} onClick={handleBook} />
		</NavLink>
	)
}
